import { render, staticRenderFns } from "./SearchResultsPanel.vue?vue&type=template&id=fdb163dc"
import script from "./SearchResultsPanel.vue?vue&type=script&lang=js"
export * from "./SearchResultsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports